import Constants from '../submodules/logictry_config/constants';
const iframeOrigin = `https://bridge.logictry.${Constants.isIphone ? 'com' : location.hostname.split('.').pop()}`;

class BroadcastChannel {
  constructor() {
    this.tab = (Math.floor(Math.random() * 10000000000000000)).toString();
    this.iframe = document.createElement('iframe');
    this.iframe.src = iframeOrigin;
    this.iframe.style.display = 'none';
    document.body.appendChild(this.iframe);
  }
  postMessage(data) {
    this.iframe.contentWindow.postMessage(
      JSON.stringify({
        ...data,
        tab: this.tab
      }),
      '*',
    );
  }
}
const singleton = new BroadcastChannel();
export default singleton;
